if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const socialSupportSections = document.querySelectorAll('.social-support-sec');

  if (socialSupportSections.length) {
    let resizeFrame = null;

    const setLeftHeight = () => {
      socialSupportSections.forEach((section) => {
        if (!section) {
          return;
        }

        const left = section.querySelector('.social-support-sec__left');
        const bg = section.querySelector('.social-support-sec__bg');

        if (!left || !bg) {
          return;
        }

        bg.style.setProperty(
          '--social-support-left-height',
          `${left.getBoundingClientRect().height}px`
        );
      });
    };

    const throttledSetLeftHeight = () => {
      if (resizeFrame) {
        return;
      }

      resizeFrame = window.requestAnimationFrame(() => {
        setLeftHeight();
        resizeFrame = null;
      });
    };

    setLeftHeight();
    window.addEventListener('resize', throttledSetLeftHeight);
  }
}
